import { ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TGetWorkerI9DataRequest,
  TGetWorkerI9DataResponse,
} from "./getWorkerI9Data.schema";

export const getWorkerI9Data = (axios: IAxiosInstance) => {
  return async (params: TGetWorkerI9DataRequest) => {
    const response = await axios.noRetry.get<
      ZealApiResponse<TGetWorkerI9DataResponse>
    >(`/api/getWorkerI9Data`, {
      params,
    });
    const resData = response.data;
    if (resData.success) {
      return resData.data;
    }
    throw new Error("Something went wrong");
  };
};
